export default "__VITE_ASSET__ZrccSiax__"